import { useState, useEffect } from 'react'
import { dropSettingCostCenterGroupAPI } from '../services/setting/cost-center'

function UseSettingCostCenterGroup() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const resp = await dropSettingCostCenterGroupAPI()
      if (!resp) return
      if (resp.status) {
        const newData = resp.result.map((d, i) => {
          return { value: d?.costGroupId, label: d?.costGroupName }
        })
        setData(newData)
      } else {
        setData([])
      }
    }
    getData()
  }, [])
  return data
}

export default UseSettingCostCenterGroup
